<template>
  <div class="nav frw fac box-sizing fje">
    <img class="tips" src="../assets/img/menu_tips.png" alt="">
    <img class="avatar" src="../assets/img/menu_avatar.png" alt="">
    <img @click="exit()" class="logout" src="../assets/img/menu_logout.png" alt="">
  </div>
</template>
<script>
import {
  getCookie,
  delCookie
} from '../utils/util'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: ''
    }
  },
  // 创建完毕Status(里面是Action)
  /** 关闭socket
  created() {
    this.global.getSocket() // openwebSocket
    this.user = getCookie('dkh_user');
  },
  mounted() {
    this.global.getonmessage()
  },
   */
  methods: {
    // 退出登录
    exit() {
      // console.log(this.global.socket)
      this.$confirm('Logout, do you want to continue?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.state.auth = ''
        setTimeout(() => {
          /** 关闭socket
          this.global.onclose()
          */
          delCookie('dkh_token');
          delCookie('dkh_user');
          delCookie('group_name');
          this.$router.push({
            path: '/login'
          })
          this.$message({
            type: 'success',
            message: 'Logged out!'
          })
        }, 1000)
      }).catch(() => {

      })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}

</script>
<style scoped>
.nav {
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(17, 170, 178, .21176470588235294);
  padding: 0 80px;
}

.tips,
.logout {
  height: 24px;
}

.avatar {
  height: 32px;
  margin: 0 20px;
}

.logout {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue